export const httpSettingsJsonSchema = {
  type: 'object',
  required: ['app', 'auth', 'services', 'logging'],
  properties: {
    app: {
      type: 'object',
      required: ['styles', 'configuration', 'serverSettingsOverride'],
      properties: {
        styles: {
          type: 'object',
          properties: {},
        },
        configuration: {
          type: 'object',
          properties: {},
        },
        serverSettingsOverride: {
          type: 'object',
          properties: {},
        },
      },
    },
    auth: {
      type: 'object',
      required: ['globalAuthSettings', 'providers'],
      properties: {
        globalAuthSettings: {
          type: 'object',
          required: ['useAuthentication', 'authProvider', 'logActivity'],
          properties: {
            useAuthentication: {
              type: 'boolean',
              default: true,
            },
            authProvider: {
              type: 'string',
            },
            logActivity: {
              type: 'boolean',
              default: true,
            },
          },
        },
        providers: {
          type: 'object',
          required: ['keycloak'],
          properties: {
            keycloak: {
              type: 'object',
              required: ['javascriptClientAssets', 'version', 'minValidityMs', 'refreshRateMs', 'configuration'],
              properties: {
                javascriptClientAssets: {
                  type: 'string',
                },
                version: {
                  type: 'string',
                },
                minValidityMs: {
                  type: 'integer',
                  default: 10000,
                },
                refreshRateMs: {
                  type: 'integer',
                  default: 1000,
                },
                configuration: {
                  type: 'object',
                  properties: {},
                },
              },
            },
          },
        },
      },
    },
    services: {
      type: 'object',
      required: ['globalServiceSettings', 'endpoints'],
      properties: {
        globalServiceSettings: {
          type: 'object',
          required: ['useMockServices'],
          properties: {
            useMockServices: {
              type: 'boolean',
              default: true,
            },
          },
        },
        endpoints: {
          type: 'object',
          properties: {},
          additionalProperties: {
            type: 'object',
            required: ['version', 'url', 'additionalHeaders', 'settings'],
            properties: {
              version: {
                type: 'string',
              },
              url: {
                type: 'string',
              },
              additionalHeaders: {
                type: 'object',
                properties: {},
              },
              settings: {
                type: 'object',
                properties: {},
              },
            },
          },
        },
      },
    },
    logging: {
      type: 'object',
      required: ['level'],
      properties: {
        level: {
          type: 'string',
          default: 'trace',
        },
      },
    },
  },
}
